import { Box, DialogTitle, DialogTitleProps } from '@mui/material';

import { CloseButton } from './CloseButton';

type DialogTitleWithCloseProps = DialogTitleProps & {
  onClose?: () => void;
};

export function DialogTitleWithClose({
  children,
  onClose,
  sx,
  ...props
}: DialogTitleWithCloseProps) {
  return (
    <Box sx={{ position: 'relative', ...sx }}>
      <DialogTitle sx={{ marginRight: onClose ? '65px' : '0px' }} {...props}>
        {children}
      </DialogTitle>
      {onClose ? (
        <Box sx={{ position: 'absolute', top: '38px', right: '56px' }}>
          <CloseButton onClick={onClose} />
        </Box>
      ) : null}
    </Box>
  );
}
